// extracted by mini-css-extract-plugin
module.exports = {"rightsReservedContainer":"footer-rights-reserved_rightsReservedContainer__f8CjE","rightsReservedLinksContainer":"footer-rights-reserved_rightsReservedLinksContainer__IoFB4"};